import {
  REQUEST_VALIDATIONISSUES_RESULTS,
  RECEIVE_VALIDATIONISSUES_RESULTS,
  ERROR_VALIDATIONISSUES_RESULTS,
  REQUEST_VALIDATIONSTATUS_RESULTS,
  RECEIVE_VALIDATIONSTATUS_RESULTS,
  ERROR_VALIDATIONSTATUS_RESULTS,
  RECEIVE_VEROSPREVIEW_UPDATE,
  RECEIVE_VEROSSUBMIT_UPDATE,
  REQUEST_CASEHEADER_RESULTS,
  REQUEST_GAAR_RESULTS,
  RECEIVE_GAAR_RESULTS,
  ERROR_GAAR_RESULTS,
} from 'typeConstants';
import { validation as initialState } from '../initialState.tsx';

const validation = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASEHEADER_RESULTS:
      return {
        ...state,
        validationIssues: [],
        validationStatus: [],
      };
    case REQUEST_VALIDATIONISSUES_RESULTS:
      return {
        ...state,
        fetchingValidationIssues: true
      };
    case RECEIVE_VALIDATIONISSUES_RESULTS:
      return {
        ...state,
        validationIssues: action.payload,
        fetchingValidationIssues: false,
        dirtyValidationIssues: false
      };
    case ERROR_VALIDATIONISSUES_RESULTS:
      return {
        ...state,
        fetchingValidationIssues: false,
        dirtyValidationIssues: false
      };
    case REQUEST_VALIDATIONSTATUS_RESULTS:
      return {
        ...state,
        fetchingValidationStatus: true
      };
    case RECEIVE_VALIDATIONSTATUS_RESULTS:
      return {
        ...state,
        validationStatus: action.payload,
        fetchingValidationStatus: false
      };
    case ERROR_VALIDATIONSTATUS_RESULTS:
      return {
        ...state,
        fetchingValidationStatus: false
      };
    case RECEIVE_VEROSPREVIEW_UPDATE:
      return {
        ...state,
        validationIssues: action.payload,
        fetchingValidationIssues: false,
        dirtyValidationIssues: false
      };
    case RECEIVE_VEROSSUBMIT_UPDATE:
      return {
        ...state,
        validationIssues: action.payload,
        fetchingValidationIssues: false,
        dirtyValidationIssues: false
      };
    case REQUEST_GAAR_RESULTS:
      return {
        ...state,
        fetchingGaarResults: true,
        gaarResults: {},
      };
    case RECEIVE_GAAR_RESULTS:
      return {
        ...state,
        fetchingGaarResults: false,
        gaarResults: action.payload,
      };
    case ERROR_GAAR_RESULTS:
      return {
        fetchingGaarResults: false,
      };
    default:
      return state;
  }
};

export default validation;
